module.exports = __webpack_public_path__ + "static/media/starNewProperty.e86eac74.svg";